'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AUIBlanket = require('./AUIBlanket');

var _AUIBlanket2 = _interopRequireDefault(_AUIBlanket);

var _document = require('./facades/document');

var _window = require('./facades/window');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AUIDialog = function (_Component) {
    _inherits(AUIDialog, _Component);

    function AUIDialog(props) {
        _classCallCheck(this, AUIDialog);

        var _this = _possibleConstructorReturn(this, (AUIDialog.__proto__ || Object.getPrototypeOf(AUIDialog)).call(this, props));

        _this.oldOverflowStyleBody = '';

        _this._onKeyDownEsc = _this._onKeyDownEsc.bind(_this);
        return _this;
    }

    _createClass(AUIDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // freeze scrolling ability of body
            this.oldOverflowStyleBody = (0, _document.body)().style.overflow;
            (0, _document.body)().style.overflow = 'hidden';

            (0, _window.addEventListener)('keydown', this._onKeyDownEsc);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // unfreeze scrolling ability of body
            (0, _document.body)().style.overflow = this.oldOverflowStyleBody;

            (0, _window.removeEventListener)('keydown', this._onKeyDownEsc);
        }
    }, {
        key: '_onKeyDownEsc',
        value: function _onKeyDownEsc(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.props.onClose();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                size = _props.size,
                titleContent = _props.titleContent,
                headerSecondaryContent = _props.headerSecondaryContent,
                headerActionContent = _props.headerActionContent,
                footerActionContent = _props.footerActionContent,
                footerHintContent = _props.footerHintContent,
                styles = _props.styles,
                styleClass = _props.styleClass,
                closeButtonText = _props.closeButtonText,
                otherProps = _objectWithoutProperties(_props, ['type', 'size', 'titleContent', 'headerSecondaryContent', 'headerActionContent', 'footerActionContent', 'footerHintContent', 'styles', 'styleClass', 'closeButtonText']);

            var classes = (0, _classnames2.default)(['aui-layer', 'aui-dialog2', 'aui-dialog2-' + size, { 'aui-dialog2-warning': type === 'warning' }, styleClass]);

            var mainHeader = titleContent ? _react2.default.createElement(
                'h2',
                { className: 'aui-dialog2-header-main' },
                titleContent
            ) : undefined;
            var secondaryHeader = headerSecondaryContent ? _react2.default.createElement(
                'div',
                { className: 'aui-dialog2-header-secondary' },
                headerSecondaryContent
            ) : undefined;
            var headerActions = headerActionContent ? _react2.default.createElement(
                'div',
                { className: 'aui-dialog2-header-actions' },
                headerActionContent
            ) : undefined;
            var closeButton = type !== 'modal' ? _react2.default.createElement(
                'a',
                { className: 'aui-dialog2-header-close', onClick: this.props.onClose },
                _react2.default.createElement(
                    'span',
                    { className: 'aui-icon aui-icon-small aui-iconfont-close-dialog' },
                    closeButtonText
                )
            ) : undefined;

            var dialogHeader = _react2.default.createElement(
                'header',
                { className: 'aui-dialog2-header ' + this.props.headerStyleClass },
                mainHeader,
                secondaryHeader,
                headerActions,
                closeButton
            );

            var dialogContent = _react2.default.createElement(
                'div',
                { className: 'aui-dialog2-content ' + this.props.contentStyleClass },
                this.props.children
            );

            var footerActions = footerActionContent ? _react2.default.createElement(
                'div',
                { className: 'aui-dialog2-footer-actions' },
                footerActionContent
            ) : undefined;
            var footerHints = footerHintContent ? _react2.default.createElement(
                'div',
                { className: 'aui-dialog2-footer-hint' },
                footerHintContent
            ) : undefined;

            var dialogFooter = _react2.default.createElement(
                'footer',
                { className: 'aui-dialog2-footer ' + this.props.footerStyleClass },
                footerActions,
                footerHints
            );
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'section',
                    _extends({ role: 'dialog', className: classes, style: styles }, otherProps),
                    dialogHeader,
                    dialogContent,
                    dialogFooter
                ),
                _react2.default.createElement(_AUIBlanket2.default, { onClick: type === 'modal' ? null : this.props.onClose })
            );
        }
    }]);

    return AUIDialog;
}(_react.Component);

AUIDialog.displayName = 'AUIDialog';


AUIDialog.propTypes = {
    /**
     * Type of the dialog including:
     * - default
     * - warning: which has a red header
     * - modal: which has no close icon at the top right corner and cannot be closed by clicking on the blanket behind it.
     */
    type: _propTypes2.default.string,
    /**
     * Size of the dialog
     */
    size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge']).isRequired,
    /**
     * The main header content for dialog
     */
    titleContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    /**
     * Dialog action actions to render on the right of the header
     */
    headerActionContent: _propTypes2.default.arrayOf(_propTypes2.default.node),
    /**
     * The secondary header content for dialog
     */
    headerSecondaryContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    /**
     * Text for close button and icon
     */
    closeButtonText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    /**
     * Main dialog content
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.array]),
    /**
     * Dialog footer hint to render on the left of the footer
     */
    footerHintContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    /**
     * Dialog footer actions to render on the right of the footer
     */
    footerActionContent: _propTypes2.default.arrayOf(_propTypes2.default.node),
    /**
     * Custom style object for the whole dialog
     */
    styles: _propTypes2.default.object,
    /**
     * Custom style class for the whole dialog
     */
    styleClass: _propTypes2.default.string,
    /**
     * Custom style class for the dialog header
     */
    headerStyleClass: _propTypes2.default.string,
    /**
     * Custom style class for the dialog content
     */
    contentStyleClass: _propTypes2.default.string,
    /**
     * Custom style class for the dialog footer
     */
    footerStyleClass: _propTypes2.default.string,
    /**
     * Callback for dialog close event
     */
    onClose: _propTypes2.default.func
};

exports.default = AUIDialog;
//# sourceMappingURL=AUIDialog.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIDialog.js
// module id = 178
// module chunks = 0